module.exports = __webpack_public_path__ + "static/media/icn_identity.81f14ed8.svg";